import React from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Form, Input, Row, Tooltip } from 'antd'
import { Controller, useWatch } from 'react-hook-form'
import { EXCEPTION_STATUS, REASON_MAPPING } from '../constants'

interface Props {
  control: any
  exceptionStatus: string
}

function ACHException(props: Props) {
  const { control, exceptionStatus } = props
  const { t } = useTranslation()

  const reasonCodes = useWatch({ control, name: 'reasons' });
  const reason = Array.isArray(reasonCodes)
    ? reasonCodes.map((code: string) => REASON_MAPPING[code] || code).join(', ')
    : reasonCodes;
  const otherReason = useWatch({ control, name: 'otherReason' });

  const finalReason = otherReason === null || otherReason === "" ? reason : otherReason;
    
  return (
    <>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item label={t('QuickExceptionProcessing:label.accountName')}>
            <Controller
              name='accountName'
              control={control}
              render={({ field }) => <Input {...field} className='ant-input-view-only' />}
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('QuickExceptionProcessing:label.achOriginatorId')}>
            <Controller
              name='achOriginatorID'
              control={control}
              render={({ field }) => <Input {...field} className='ant-input-view-only' />}
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('QuickExceptionProcessing:label.secCode')}>
            <Controller
              name='secCode'
              control={control}
              render={({ field }) => <Input {...field} className='ant-input-view-only' />}
              disabled
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label={t('QuickExceptionProcessing:label.debitCredit')}>
            <Controller
              name='debitOrCredit'
              control={control}
              render={({ field }) => <Input {...field} className='ant-input-view-only' />}
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('QuickExceptionProcessing:label.transactionCode')}>
            <Controller
              name='transactionCode'
              control={control}
              render={({ field }) => <Input {...field} className='ant-input-view-only' />}
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('QuickExceptionProcessing:label.paidDate')}>
            <Controller
              name='paidDate'
              control={control}
              render={({ field }) => <Input {...field} className='ant-input-view-only' />}
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          {exceptionStatus?.toLowerCase() === EXCEPTION_STATUS.PAID ||
          exceptionStatus?.toLowerCase() === EXCEPTION_STATUS.RETURNED ? (
            <Form.Item label={t('QuickExceptionProcessing:label.decision')}>
              <Controller
                name='decision'
                control={control}
                render={({ field }) => <Input {...field} className='ant-input-view-only' />}
                disabled
              />
            </Form.Item>
          ) : (
            <Form.Item label={t('QuickExceptionProcessing:label.defaultDecision')}>
              <Controller
                name='defaultDecision'
                control={control}
                render={({ field }) => <Input {...field} className='ant-input-view-only' />}
                disabled
              />
            </Form.Item>
          )}
        </Col>
        <Col span={8}>
          {exceptionStatus?.toLowerCase() === EXCEPTION_STATUS.PAID ||
          exceptionStatus?.toLowerCase() === EXCEPTION_STATUS.RETURNED ? (
            <Form.Item label={t('QuickExceptionProcessing:label.decisionTime')}>
              <Controller
                name='decisionTime'
                control={control}
                render={({ field }) => (
                  <Tooltip placement='right' title={field?.value} color='white' trigger='hover' arrow={false}>
                    <Input {...field} className='ant-input-view-only long-text' />
                  </Tooltip>
                )}
                disabled
              />
            </Form.Item>
          ) : (
            <Form.Item label={t('QuickExceptionProcessing:label.decisionDueDate')}>
              <Controller
                name='decisionDueDate'
                control={control}
                render={({ field }) => (
                  <Tooltip placement='right' title={field?.value} color='white' trigger='hover' arrow={false}>
                    <Input {...field} className='ant-input-view-only long-text' />
                  </Tooltip>
                )}
                disabled
              />
            </Form.Item>
          )}
        </Col>
        {exceptionStatus?.toLowerCase() === EXCEPTION_STATUS.EXCEPTION ||
        exceptionStatus?.toLowerCase() === EXCEPTION_STATUS.PROCESSING ? (
          <Col span={8}>
            <Form.Item label={t('QuickExceptionProcessing:label.cutoffTime')}>
              <Controller
                name='cutoffTime'
                control={control}
                render={({ field }) => <Input {...field} className='ant-input-view-only' />}
                disabled
              />
            </Form.Item>
          </Col>
        ) : (
          <></>
        )}
        {(exceptionStatus?.toLowerCase() === EXCEPTION_STATUS.PAID ||
          exceptionStatus?.toLowerCase() === EXCEPTION_STATUS.RETURNED) && (
          <React.Fragment>
            <Col span={8}>
              <Form.Item label={t('QuickExceptionProcessing:label.reason')}>
                <Controller
                  name='reasons'
                  control={control}
                  render={({ field }) => <Input {...field} value={finalReason} className='ant-input-view-only' />}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={t('QuickExceptionProcessing:label.decisionedBy')}>
                <Controller
                  name='decisionedBy'
                  control={control}
                  render={({ field }) => <Input {...field} className='ant-input-view-only' />}
                  disabled
                />
              </Form.Item>
            </Col>
          </React.Fragment>
        )}

        <Col span={8}>
          <Form.Item label={t('QuickExceptionProcessing:label.transactionDescription')}>
            <Controller
              name='transactionDescription'
              control={control}
              render={({ field }) => (
                <Tooltip placement='right' title={field?.value} color='white' trigger='hover' arrow={false}>
                  <Input {...field} className='ant-input-view-only long-text' />
                </Tooltip>
              )}
              disabled
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}

export default ACHException
